import React from 'react';
import { Stack, Button } from '@mui/material';
import DocumentForm from './DocumentForm';

export default function AddDocument ({ setDocuments, submitDocumentAction, getDocumentsAction, setCount }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Stack justifyContent="center" alignItems="center">
        <Button variant="contained" onClick={handleOpen}>
          Dodaj Plik
        </Button>
      </Stack>
      <DocumentForm
        open={open}
        handleClose={handleClose}
        setDocuments={setDocuments}
        submitDocumentAction={submitDocumentAction}
        getDocumentsAction={getDocumentsAction}
        setCount={setCount} />
    </>
  );

};
